'use client';

import React, { Suspense, lazy } from 'react';
import SubHeader from '../font/subheader';
import Header from '../font/header1';
import user_with_phone from '../../img/user_with_phone.png';

const CityMap = lazy(() => import('../cityMap/CityMap'));

const APP_SIGNUP_URL = 'https://app.homebutler.us';

const HeroSection = ({ currentCityData }) => {
    const hasMap = currentCityData.lat && currentCityData.lon;

    return (
        <div id='section1' className='flex flex-col lg:flex-row lg:justify-evenly justify-center pl-12 pr-12'>
            <div className='flex flex-col lg:w-1/3'>
                <SubHeader>HomeButler</SubHeader>
                <Header left='True'>Welcome to {currentCityData.cityName}</Header>
                <p className='pt-5'>{currentCityData.description}</p>
                <a href={APP_SIGNUP_URL} className='mt-6 bg-pink rounded-full h-14 text-white flex items-center justify-center w-fit px-10'>Sign up free</a>
            </div>
            <div className='flex justify-center w-full lg:w-auto lg:place-self-end pt-8 lg:pt-0'>
                {hasMap ? (
                    <Suspense fallback={<div className='rounded-lg h-96 w-full lg:w-[420px] bg-lightblue animate-pulse' />}>
                        <CityMap lat={currentCityData.lat} lon={currentCityData.lon} cityName={currentCityData.cityName} />
                    </Suspense>
                ) : (
                    <img className='h-96 place-self-center' src={currentCityData.backgroundImage || user_with_phone} alt={`HomeButler home maintenance tracker for ${currentCityData.cityName}`} />
                )}
            </div>
        </div>
    );
};

export default HeroSection;
